<aside class="filter-global-wrapper" (bzOutside)="mobileClosedFilters()" (swipeleft)="mobileClosedFilters()">
  <div class="block-filters-panel">
    <span class="closed-filters" (click)="closedFilters()"></span>
    <div class="btn-wrapper">
      <div class="btn-filter-reset" (click)="clearFilters()">
        {{'unsetAll' | transloco}}
      </div>
    </div>
    <div class="selected-filters">
      <span class="filter-tab" [ngClass]="{'active-border' : filterState === 0}"
        (click)="changeFilterTabsState(0)">{{'all' | transloco}}</span>
      <span class="filter-tab" [ngClass]="{'active-border' : filterState === 1}"
        (click)="changeFilterTabsState(1)">{{'selectedFilters' | transloco}} ({{currentFiltersLength |
        async}})</span>
    </div>
  </div>

  <div class="wrapper-filters-sections scrollbar">
    <div class="scrollable-block" *ngIf="filterState === 0">
      <div class="section" *ngFor="let section of (data | async) | keyvalue">

        <span class="category-title cursor" (click)="switch(section.key)">
          <span class="header-section" [textContent]="section.key | transloco"></span>
          <span [ngClass]="{'down': split(section.key), 'up': !split(section.key)}"
            class="switch-category switch-category-mask cursor"></span>
        </span>

        <ng-container *ngIf="split(section.key)">
          <div class="animation-wrapper">
            <ng-container *ngIf="section.key !== '1012_tnf'">
              <span *ngFor="let element of section.value" class="elem-section">
                <input class="cursor" [id]="section.key + element.id + element.name" #selectFilter
                  [checked]="element.checked" (change)="changeFilter(section.key, element, selectFilter)" type="checkbox">
  
                <label [for]="section.key + element.id + element.name" class="cursor">
                  {{element.name}}
                  <span *ngIf="element?.qty" class="additional">({{element.qty}})</span>
                  <span *ngIf="element?.add" class="additional">{{element.add}}</span>
                </label>
              </span>
            </ng-container>

            <ng-container *ngIf="section.key === '1012_tnf'">
              <span *ngFor="let element of section.value" class="elem-section">
                <input class="cursor" [id]="section.key + element.id + element.name" #selectFilter
                  [checked]="element.checked" (change)="changeFilter(section.key, element, selectFilter)" type="checkbox">
  
                <label [for]="section.key + element.id + element.name" class="cursor">
                  <a class="filter-name-with-link" [routerLink]="element.nameEn | filtersListLink">{{ element.name }}</a>
                  <span *ngIf="element?.qty" class="additional">({{ element.qty }})</span>
                  <span *ngIf="element?.add" class="additional">{{ element.add }}</span>
                </label>
              </span>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <span class="elem-section empty"></span>
    </div>

    <div class="scrollable-block" [ngStyle]="{'padding-top' : filterState === 1 ? '5px' : '' }"
      *ngIf="filterState === 1">
      <div class="current-filters-wrapper">
        <div *ngFor="let filter of (currentFiltersKeys | async)">
          <span class="current-filter-category">{{filter | transloco}}</span>
          <div class="active-filters-wrapper">
            <ng-container *ngFor="let item of (currentFilters | async)">
              <span *ngIf="item.group == filter" class="current-filter"
                (click)="cancelFilterByClick(bufferFilterMap, item); deleteFilterFromStore(item.id);  $event.stopPropagation()">
                <span class="filter-inner-text">{{item?.name}}</span>
              </span>
            </ng-container>
          </div>
        </div>
        <p class="no-filters" *ngIf="(currentFilters | async)?.length === 0">{{'noCurrentFilters' | transloco}}.</p>
      </div>
    </div>
  </div>
</aside>
